import axios from 'axios';
import { EncounterPatientEducation } from '../models/encounter-patient-education';

export const getEncounterPatientEducations = async (appointmentId: number): Promise<Undefinable<EncounterPatientEducation[]>> => {
    const response = await axios.get(`/api/encounter-patient-education/appointment/${appointmentId}`);
    return response.data;
};
